import { isNullable } from '@app/utils'

import { InternalTasksNotificationDto } from '@app/api/routes/internalTasksNotification/dtos'
import { INTERNAL_TASKS_PAGE } from '@app/constants/page'

import type { NotificationData } from './types'

export const checkForNewNotification = (notificationList?: NotificationData[]): boolean => {
  if (isNullable(notificationList)) {
    return false
  }

  return notificationList.some(item => item.isNew)
}

export const notificationListAdapter = (
  internalTasksNotificationData?: InternalTasksNotificationDto[]
): NotificationData[] | undefined => {
  return internalTasksNotificationData?.map(internalTasksNotification => {
    const { id, createdAt, title, text, isNew, internalTask } = internalTasksNotification

    return {
      id,
      createdAt,
      title,
      text,
      isNew,
      relatedEntityId: internalTask,
      baseSectionUrl: INTERNAL_TASKS_PAGE.internalTasks
    }
  })
}
